import services from './../../../services/service'; // Service Class
let service = new services();

export default {
    name: 'Account',
    data () {
        return {
            user: {},
            sellpoints:{},
            img_url: service.imageURL,
            user_business_interests: {},
        }
    },
    components: {
        
     },
    methods: {
        preset() {
            var credentials = {
                session_key: localStorage.getItem("sp_token")
            } 
            if(credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        let data = response.body.data;
                        data.forEach(function(element) {
                           // this.user.user_id = element.user_id;
                            //special case for profile
                            service.getUser(this, element.user_id).then(data => {
                                if(data.body.status == 200) {
                                    this.user = data.body.data;
                                     //get sellpoints
                                    this.getSellpoints(element.user_id);

                                    //get Users Interests
                                    this.getUserBusinessInterests(element.user_id);
                                }
                            }).catch((err) => {
                                if(err) {
                                    toastr.error('Sorry, could not process information', 'Warning!');
                                }
                            })
                         //../special case for profile
                         }, this);
                    }else {
                       this.$router.push('login');
                      }
                }).catch((err) => {
                    if(err) {
                        //console.log(err)
                        this.$router.push('login');
                    }
                })
            }else {
                this.$router.push('login');
            }
        },

    
        getSellpoints(user){
            service.getBusinesses(this, user).then(data => {
                if(data.body.status == 200) {
                    this.sellpoints = data.body.data;
                }
            }).catch((err) => {
                if(err) {
                   //log it
                   console.log(err)
                }
            })
        },

        getUserBusinessInterests(user){
            service.getUserBusinessInterests(this, user).then(data => {
                if(data.body.status == 200) {
                    this.user_business_interests = data.body.data;
                }
            }).catch((err) => {
                if(err) {
                   //log it
                   console.log(err)
                }
            })
        },

    },
    created: function(){
        document.title = "Account" + " | SP";
        this.preset();
    }
}


// WEBPACK FOOTER //
// ./src/pages/Buypoint/Account/script.js